import { TBucketItem, TCreateSendBucketItem } from '../../../types/bucket';
import { ICampaign } from '../../../types/campaigns';
import {
  IChangeContentsItemValuePayload,
  ISetContentsActiveTabPayload,
  ISetContentsItemSkuOptionsPayload,
} from '../../../types/createSendContents';
import { IGiftBudget } from '../../../types/marketplace';

export const SET_CS_CONTENTS_ACTIVE_TAB = 'SET_CS_CONTENTS_ACTIVE_TAB';
export const TOGGLE_CS_KIT = 'TOGGLE_CS_KIT';
export const SET_CS_KITS = 'SET_CS_KITS';
export const SET_CS_GIFT_CHOICE_MODE = 'SET_CS_GIFT_CHOICE_MODE';
export const RESET_CS_CUSTOM_KIT = 'RESET_CS_CUSTOM_KIT';
export const APPLY_CS_CUSTOM_KIT = 'APPLY_CS_CUSTOM_KIT';
export const SET_CS_BOX_ID = 'SET_CS_BOX_ID';
export const ADD_CS_ITEM = 'ADD_CS_ITEM';
export const REMOVE_CS_ITEM = 'REMOVE_CS_ITEM';
export const CHANGE_CS_ITEM_VALUE = 'CHANGE_CS_ITEM_VALUE';
export const SET_CS_GIFT_BUDGET = 'SET_CS_GIFT_BUDGET';
export const SET_CS_ITEM_SKU_OPTIONS = 'SET_CS_ITEM_SKU_OPTIONS';
export const SET_CS_PYG_OPTION_ORDER = 'SET_CS_PYG_OPTION_ORDER';

export const setContentsActiveTab = (payload: ISetContentsActiveTabPayload) => ({
  type: SET_CS_CONTENTS_ACTIVE_TAB,
  payload,
});

export const toggleCsKit = (payload: ICampaign) => ({
  type: TOGGLE_CS_KIT,
  payload,
});

export const setCsKits = (payload: ICampaign[] | null) => ({
  type: SET_CS_KITS,
  payload,
});

export const setCsPygOptionOrder = (payload: string[]) => ({
  type: SET_CS_PYG_OPTION_ORDER,
  payload,
});

export const setCsGiftChoiceMode = (payload: boolean) => ({
  type: SET_CS_GIFT_CHOICE_MODE,
  payload,
});

export const resetCsCustomKit = () => ({
  type: RESET_CS_CUSTOM_KIT,
});

export const applyCsCustomKit = (payload: TBucketItem[]) => ({
  type: APPLY_CS_CUSTOM_KIT,
  payload,
});

export const setCsBoxId = (payload: string) => ({
  type: SET_CS_BOX_ID,
  payload,
});

export const addCsItem = (payload: TCreateSendBucketItem) => ({
  type: ADD_CS_ITEM,
  payload,
});

export const removeCsItem = (payload: string) => ({
  type: REMOVE_CS_ITEM,
  payload,
});

export const changeCsItemValue = (payload: IChangeContentsItemValuePayload) => ({
  type: CHANGE_CS_ITEM_VALUE,
  payload,
});

export const setCsGiftBudget = (payload: IGiftBudget | null, isPending = false) => ({
  type: SET_CS_GIFT_BUDGET,
  payload,
  meta: { isPending },
});

export const setCsItemSkuOptions = (payload: ISetContentsItemSkuOptionsPayload) => ({
  type: SET_CS_ITEM_SKU_OPTIONS,
  payload,
});
